var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.996,
    height: 18,
    viewBox: "0 0 19.996 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff5a5a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_26\\u611F\\u53F9\\u53F7-\\u7EBF\\u6027\\u4E09\\u89D2\\u6846",
    "data-name": "26\\u611F\\u53F9\\u53F7-\\u7EBF\\u6027\\u4E09\\u89D2\\u6846",
    transform: "translate(-63.803 -108.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35470",
    "data-name": "\\u8DEF\\u5F84 35470",
    className: "cls-1",
    d: "M451.97,358.147a1.382,1.382,0,0,0-1.37,1.372,1.3,1.3,0,0,0,.4.959,1.347,1.347,0,0,0,.712.373c.085,0,.167.007.254.007s.17,0,.254-.007a1.323,1.323,0,0,0,.712-.373,1.287,1.287,0,0,0,.4-.959,1.382,1.382,0,0,0-1.37-1.372Zm0-7.147a1.286,1.286,0,0,0-.986.419,1.455,1.455,0,0,0-.384,1.028c0,.357.58,2.976.736,4.881h1.287c.179-1.905.714-4.524.714-4.881a1.46,1.46,0,0,0-.384-1.035A1.288,1.288,0,0,0,451.972,351Z",
    transform: "translate(-378.168 -237.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35471",
    "data-name": "\\u8DEF\\u5F84 35471",
    className: "cls-1",
    d: "M66.527,126.5a2.418,2.418,0,0,1-2.244-3.886l7.275-12.6a2.418,2.418,0,0,1,4.488,0l7.275,12.6a2.416,2.416,0,0,1-2.242,3.884l-14.551,0ZM73.8,109.95c-.337,0-.7.29-.988.794l-7.275,12.6a1.013,1.013,0,0,0,.988,1.713H81.076a1.013,1.013,0,0,0,.988-1.713l-7.272-12.6C74.5,110.238,74.138,109.95,73.8,109.95Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarn);
export default __webpack_public_path__ + "static/media/icon--warn.8cea4d09c671ad56f9db7b3ce76df448.svg";
export { ForwardRef as ReactComponent };